enum SButtonVariantEnum {
  FILLED = 'filled',
  TERTIARY = 'tertiary',
  TRANSPARENT = 'transparent',
}

export default SButtonVariantEnum;
